<template>
  <div>
    <verify-address
      v-if="verifyAddress"
      :default-address="defaultAddress"
      :default-city="defaultCity"
      :default-state="defaultState"
      :staff-override="showStaffTools"
      :addItemObj="addItemObj"
      :mapCenterLat="mapCenterLat"
      :mapCenterLng="mapCenterLng"
      :restZone="restZone"
      :restName="restInfoBanner.name"
    />
    <div class="page-wrapper">
      <div v-if="blockedMessage" v-html="blockedMessage">
        {{ blockedMessage }}
      </div>
      <div v-if="closedMessage" v-html="closedMessage">
        {{ closedMessage }}
      </div>
      <rest-info-modal
        :showModal="infoOpen"
        @close-modal="closeInfo"
        :title="restInfoModal.title"
        :street="restInfoModal.street"
        :cityStZip="restInfoModal.cityStZip"
        :phone="restInfoModal.phone"
        :restHours="restInfoModal.restHours"
        :logo="restInfoModal.logo"
        :map="restInfoModal.map"
        :restColor="restColor"
      />

      <later-order-modal
        v-if="showLaterOrder"
        @goToMenu="hideLaterOrderModal()"
        @hideModal="hideLaterOrderModal"
        :restId="restId"
        :hours="restInfoModal.restAndMenuHours"
        :restName="restInfoBanner.name"
      ></later-order-modal>

      <add-item-modal
        v-if="addItemOpen"
        :showAddItem="addItemOpen"
        @close-modal="closeAddItem"
        @getAddress="handleGetAddress"
        :restId="restId"
        :restName="restInfoBanner.name"
        :showVerifyAddress="showVerifyAddress"
      />

      <edit-item-modal
        v-if="editItemOpen"
        :showEditItem="editItemOpen"
        @close-modal="closeEditItem"
        @getAddress="handleGetAddress"
        :restId="restId"
        :restName="restInfoBanner.name"
        :showVerifyAddress="showVerifyAddress"
      />

      <page-banner v-if="showAlert" :title="pageBanner.title" :copy="pageBanner.copy" :url="pageBanner.url" />
      <menu-hero :backgroundImage="menuHero.backgroundImage" :restLogo="menuHero.restLogo" />
      <rest-info-banner
        @showInfo="openInfo"
        @showDelTime="showLaterOrderModal"
        @deliveryASAP="setDeliveryASAP"
        :name="restInfoBanner.name"
        :tags="restInfoBanner.tags"
        :isPartner="restInfoBanner.isPartner"
        :nonPartnerMessage="restInfoBanner.nonPartnerMessage"
        :deliveryCost="restInfoBanner.deliveryCost"
        :distance="restInfoBanner.distance"
        :deliveryTime="deliveryTime"
        :waitTime="restInfoBanner.waitTime"
        :restColor="restColor"
        :cityName="restInfoBanner.cityName"
        :showMenuEditLink="restInfoBanner.showMenuEditLink"
        :restId="restId"
      />

      <div class="sticky-wrapper" id="menu-tabs-section">
        <menu-type-tabs :menuTypes="menuTypesObject" :restColor="restColor" @handle-menu-switch="menuSwitch" />
        <menu-categories :categories="currentCategories" :cartCount="cartCount" />
      </div>

      <menu-allergy-filter
        :allergyFilters="currentAllergyFilters"
        :selectedAllergyFilters="selectedAllergyFilters"
        @filterSelected="filterMenuByAllergy"
      />
      <add-special-item v-if="showSpecialItem" :restId="restId" :restName="restInfoBanner.name" />
      <menu-card-list
        @showAddItemModal="openCurrentItem"
        v-for="menuCardList in currentMenuCardList"
        :restId="restId"
        :key="menuCardList.id"
        :id="menuCardList.id"
        :title="menuCardList.title"
        :description="menuCardList.description"
        :cards="menuCardList.cards"
      />
    </div>
  </div>
</template>

<script>
import PageBanner from './PageBanner.vue'
import RestInfoModal from './RestInfoModal.vue'
import AddItemModal from './AddItemModal.vue'
import EditItemModal from './EditItemModal.vue'
import AddSpecialItem from './AddSpecialItem.vue'
import MenuHero from './MenuHero.vue'
import RestInfoBanner from './RestInfoBanner.vue'
import MenuTypeTabs from './MenuTypeTabs.vue'
import MenuCategories from './MenuCategories.vue'
import MenuAllergyFilter from './MenuAllergyFilter.vue'
import MenuCardList from './MenuCardList.vue'
import VerifyAddress from './VerifyAddressModal.vue'
import LaterOrderModal from './LaterOrderModal.vue'

import ScrollLock from './utilities/scroll-lock'

import { mapMutations, mapActions, mapState } from 'vuex'

export default {
  name: 'RestMenu',
  components: {
    PageBanner,
    RestInfoModal,
    AddItemModal,
    EditItemModal,
    LaterOrderModal,
    AddSpecialItem,
    MenuHero,
    RestInfoBanner,
    MenuTypeTabs,
    MenuCategories,
    MenuAllergyFilter,
    MenuCardList,
    VerifyAddress,
  },
  props: {
    pageBanner: {
      type: Object,
      default: () => {},
    },
    restInfoModal: {
      type: Object,
      default: () => {},
    },
    menuHero: {
      type: Object,
      default: () => {},
    },
    restInfoBanner: {
      type: Object,
      default: () => {},
    },
    deliveryTime: {
      type: Object,
      default: () => {},
    },
    menuTabs: {
      type: Array,
      default: () => [],
    },
    restId: [String, Number],
    restColor: String,
    cartCount: [String, Number],
    showSpecialItem: {
      type: Boolean,
      default: false,
    },
    blockedMessage: {
      type: String,
      default: '',
    },
    closedMessage: {
      type: String,
      default: '',
    },
    defaultAddress: String,
    defaultCity: String,
    defaultState: String,
    showVerifyAddress: String,
    mapCenterLat: [String, Number],
    mapCenterLng: [String, Number],
    restZone: [String, Number],
    initDefaultTab: Object,
  },
  // mounted() {
  //   this.$nextTick(function () {
  //     if (this.pageBanner.copy && this.pageBanner.copy.trim().length) {
  //       this.showAlert = true
  //     }
  //   })
  // },
  data: function () {
    return {
      infoOpen: false,
      addItemOpen: false,
      menus: this.menuTabs,
      menuTypesObject: this.menuTabs.map((menuType, index) => {
        return {
          label: menuType.label,
          id: menuType.id,
          isActive: menuType.id == this.initDefaultTab.id,
        }
      }),
      currentCategories: this.initDefaultTab.categories,
      currentMenuCardList: this.initDefaultTab.menuCategoryList,
      currentAllergyFilters: this.initDefaultTab.menuAllergyFilters,
      currentTab: this.initDefaultTab.id,
      selectedAllergyFilters: [],
      verifyAddress: false,
      addItemObj: {},
      showAlert: this.pageBanner.copy ? (this.pageBanner.copy.trim().length ? true : false) : false,
      showLaterOrder: false,
    }
  },
  computed: {
    ...mapState({
      editItemOpen: (state) => state.restMenu.editItemOpen,
      showStaffTools: (state) => state.restMenu.restInfo.showStaffTools,
    }),
  },
  methods: {
    ...mapActions({
      getCurrentItem: 'restMenu/getCurrentItem',
      openCloseEditItemModal: 'restMenu/openCloseEditItemModal',
      updateShowCart: 'restMenu/updateShowCart',
      updateDeliveryASAP: 'restMenu/updateDeliveryASAP',
    }),
    ...mapMutations({
      setIsCurrentItemLoaded: 'restMenu/setIsCurrentItemLoaded',
      setIsCurrentEditItemLoaded: 'restMenu/setIsCurrentEditItemLoaded',
    }),
    showLaterOrderModal() {
      ScrollLock.enable()
      this.showLaterOrder = true
      this.$nextTick(function () {
        document.getElementById('later-datepicker').focus()
      })
    },
    hideLaterOrderModal() {
      ScrollLock.disable()
      this.showLaterOrder = false
    },
    setDeliveryASAP() {
      this.updateDeliveryASAP()
    },
    handleGetAddress(payload) {
      this.addItemObj = payload
      this.verifyAddress = true
    },
    openInfo() {
      this.infoOpen = true
      ScrollLock.enable()
    },
    closeInfo() {
      this.infoOpen = false
      ScrollLock.disable()
    },
    closeAddItem() {
      this.addItemOpen = false
      this.setIsCurrentItemLoaded(false)
      ScrollLock.disable()
    },
    closeEditItem() {
      this.openCloseEditItemModal(false)
      this.setIsCurrentEditItemLoaded(false)
      this.updateShowCart(true)
      this.$nextTick(function () {
        document.getElementById('close-cart').focus()
      })
    },
    openCurrentItem(itemId) {
      this.getCurrentItem({ restId: this.restId, itemId: itemId })
      this.addItemOpen = true
      ScrollLock.enable()
    },
    menuSwitch(menuId) {
      const activeTabIndex = this.menus.findIndex((tab) => tab.id === menuId)

      this.currentCategories = this.menus[activeTabIndex].categories
      this.currentMenuCardList = this.menus[activeTabIndex].menuCategoryList
      this.currentAllergyFilters = this.menus[activeTabIndex].menuAllergyFilters
      this.currentTab = this.menus[activeTabIndex].id
    },
    filterMenuByAllergy(allergyId) {
      const activeTabIndex = this.menus.findIndex((tab) => tab.id === this.currentTab)
      this.currentMenuCardList = this.menus[activeTabIndex].menuCategoryList

      if (allergyId !== 'all') {
        var allergyIndex = this.selectedAllergyFilters.findIndex((allergy) => allergy === allergyId)
        if (allergyIndex === -1) {
          this.selectedAllergyFilters.push(allergyId)
        } else {
          this.selectedAllergyFilters = this.selectedAllergyFilters.filter((allergy) => allergy !== allergyId)
          if (this.selectedAllergyFilters.length === 0) {
            return false
          }
        }
        var groups = JSON.parse(JSON.stringify(this.currentMenuCardList))
        var filteredMenu = groups.filter((group) => {
          group.cards = group.cards.filter((item) => {
            var result = false
            for (const ALLERGY of this.selectedAllergyFilters) {
              if (item[ALLERGY]) {
                result = true
              } else {
                result = false
                break
              }
            }
            if (result) {
              return true
            } else {
              return false
            }
          })
          if (group.cards.length) {
            return true
          } else {
            return false
          }
        })
        this.currentMenuCardList = filteredMenu
      } else {
        this.selectedAllergyFilters = []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  &.cart-open {
    &::after {
      content: '';
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 5;
    }
  }
}

.sticky-wrapper {
  position: sticky;
  z-index: 1;
  top: 0px;
}
</style>
